import { getTableData, deleteItem, find, update, save } from '@/axios/api/coowner'
const UPDATE_SEARCH = 'UPDATE_SEARCH'
const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_DETAIL_LOADING = 'UPDATE_DETAIL_LOADING'
const UPDATE_DETAIL = 'UPDATE_DETAIL'

const state = {
  params: {
    locationId: undefined,
    roleId: undefined,
    account: undefined
  },
  tblLoading: false,
  tableData: [],
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  detailLoading: false,
  detail: {}
}

const getters = {
  params: state => state.params,
  tblLoading: state => state.tblLoading,
  tableData: state => state.tableData,
  pager: state => state.pager,
  detailLoading: state => state.detailLoading,
  detail: state => state.detail
}

const mutations = {
  [UPDATE_SEARCH] (state, { pager, params }) {
    state.pager = { ...state.pager, ...pager }
    if (params) state.params = params
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  },
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_DETAIL_LOADING] (state, detailLoading) {
    state.detailLoading = detailLoading
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  }
}

const actions = {
  // 获取列表数据
  async getTableDataApi ({ commit }, params) {
    commit(UPDATE_TBL_LOADING, true)
    try {
      let { data: res } = await getTableData({
        ...params
      })
      commit(UPDATE_TABLEDATA, res.records)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) { }
    commit(UPDATE_TBL_LOADING, false)
  },
  // 设置page
  setPagerApi ({ commit }, pager) {
    commit(UPDATE_SEARCH, { pager })
  },
  // 删除
  async deleteApi ({commit}, params) {
    try {
      await deleteItem(params)
      return true
    } catch (e) {
      return false
    }
  },
  // 获取详情
  async getDetailApi ({ commit }, params) {
    commit(UPDATE_DETAIL_LOADING, true)
    try {
      const {data: res} = await find(params)
      commit(UPDATE_DETAIL, res)
    } catch (e) {}
    commit(UPDATE_DETAIL_LOADING, false)
  },
  // 编辑
  async updateApi ({commit}, params) {
    commit(UPDATE_DETAIL_LOADING, true)
    try {
      const res = await update(params)
      commit(UPDATE_DETAIL_LOADING, false)
      return res && res.errorCode === 200
    } catch (e) {
      commit(UPDATE_DETAIL_LOADING, false)
      return false
    }
  },
  // 新增
  async saveApi ({commit}, params) {
    commit(UPDATE_DETAIL_LOADING, true)
    try {
      const res = await save(params)
      commit(UPDATE_DETAIL_LOADING, false)
      return res && res.errorCode === 200
    } catch (e) {
      commit(UPDATE_DETAIL_LOADING, false)
      return false
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/coowner.js